var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { ToneEntry } from './tone-entry';
import { TimeUnit, MathUtil } from './../../util/index';
import { AppBus } from './../../app_bus/app-bus';
import { ToneRemovedEvent, ToneAddedEvent, ToneEndedEvent } from './events/index';
export let ToneEntryComponent = class ToneEntryComponent {
    constructor(appBus) {
        this.appBus = appBus;
        this.TimeUnit = TimeUnit;
        this.MathUtil = MathUtil;
    }
    ngOnInit() {
        this.entry.onEnded.subscribe(Void => this.appBus.publish(new ToneEndedEvent(this.entry)));
    }
    clickRemove() {
        this.appBus.publish(new ToneRemovedEvent(this.entry));
    }
    validateInputNumber(text) {
        return Number(text) && Number(text) > 0;
    }
    addEntryIfTemp(entry) {
        if (entry.temp) {
            entry.temp = false;
            this.appBus.publish(new ToneAddedEvent());
        }
    }
};
__decorate([
    Input(), 
    __metadata('design:type', ToneEntry)
], ToneEntryComponent.prototype, "entry", void 0);
ToneEntryComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'tone-entry-component',
        styleUrls: ['tone-entry.css'],
        templateUrl: 'tone-entry.html'
    }), 
    __metadata('design:paramtypes', [AppBus])
], ToneEntryComponent);
//# sourceMappingURL=tone-entry.component.js.map